module.exports = __webpack_public_path__ + "img/photog-white.bad49a6d.png";